/**
 * @generated SignedSource<<b96518ec3d384c2e0fa6e03f714131d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedNewForm_root$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ActivityForm_root">;
  readonly " $fragmentType": "FeedNewForm_root";
};
export type FeedNewForm_root$key = {
  readonly " $data"?: FeedNewForm_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedNewForm_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedNewForm_root",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityForm_root"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "da23d13bc5c9a4392f48656095315c75";

export default node;
